import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export const LegalLayout = ({ title, updated, intro, sections }) => {
  return (
    <div className="bg-paper min-h-screen" data-testid="legal-page">
      <Navbar />
      <main className="pt-36 md:pt-44 pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-ink-soft hover:text-brand transition-colors mb-10" data-testid="legal-back">
            <ArrowLeft className="w-4 h-4" /> Back to home
          </Link>

          <p className="overline text-brand">Legal</p>
          <h1 className="mt-4 font-heading font-extrabold text-4xl md:text-5xl tracking-tight text-ink leading-tight">
            {title}
          </h1>
          <p className="mt-4 text-sm text-ink-faint font-mono">Last updated: {updated}</p>

          <div className="mt-10 space-y-3 text-ink-soft leading-relaxed text-lg">
            {intro.map((p) => <p key={p}>{p}</p>)}
          </div>

          <div className="mt-12 space-y-12">
            {sections.map((s, i) => (
              <section key={s.heading} className="scroll-mt-28">
                <h2 className="font-heading font-bold text-2xl text-ink tracking-tight">
                  <span className="text-brand mr-3 font-mono text-lg align-middle">{String(i + 1).padStart(2, "0")}</span>
                  {s.heading}
                </h2>
                <div className="mt-4 space-y-3 text-ink-soft leading-relaxed">
                  {s.body.map((b) =>
                    typeof b === "string" ? (
                      <p key={b}>{b}</p>
                    ) : (
                      <ul key={`list-${b.list[0]}`} className="list-disc pl-6 space-y-2 marker:text-brand">
                        {b.list.map((li) => <li key={li}>{li}</li>)}
                      </ul>
                    )
                  )}
                </div>
              </section>
            ))}
          </div>

          <div className="mt-16 rounded-2xl bg-white border border-black/5 p-6">
            <p className="text-sm text-ink-soft">
              Questions about this policy? Contact us at{" "}
              <a href="mailto:stayflow.admin@gmail.com" className="text-brand font-medium">stayflow.admin@gmail.com</a>{" "}
              or write to StayFlow, 163, Jyoti Nagar, Bongaon, Part - 3, Golaghat, Assam - 785621 (India).
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LegalLayout;
